<template>
  <div class="columns">
    <div class="column" v-for="card in section_one" :key="card.title">
      <div class="box has-text-centered">
        <p class="heading mb-3">{{ card.title }}</p>
        <p class="title">{{ card.value }}</p>
      </div>
    </div>
  </div>
  <div class="columns">
    <div class="column" v-for="card in section_two" :key="card.title">
      <div class="box has-text-centered">
        <p class="heading mb-3">{{ card.title }}</p>
        <p class="title">{{ card.value }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { formatDateTH } from '@/utils/date'

const today = formatDateTH()

const section_one = ref([
  { title: 'สรุปข้อมูลประจำวันที่', value: today },
  { title: 'จำนวนจุดความร้อน', value: 890 },
])

const section_two = ref([
  { title: 'Hotspots Today', value: 245 },
  { title: 'This Week', value: 1340 },
  { title: 'High Risk Provinces', value: 12 },
  { title: 'Avg Brightness', value: 342 }
])

</script>
